module.exports = __webpack_public_path__ + "img/mirror26.dc8fca90.jpg";